<template>
  <div class="mask">
    <div class="otherall">
      <p class="othertitle">Item selection</p>
      <div class="othercontent">
         <div v-for="(l,i) in otherlist" @click="changeother(l)" :class="{'otheritem':true,'otherselsct':select.unique_identify == l.unique_identify}" :keys="i">
           <img :src="l.pic_url" />
           <span>{{ ' X' + setcount(l.count?l.count:l.main_number)}}</span>
           <img class="otherimg" v-show="select.unique_identify == l.unique_identify" src="static/images/otherok.png" />
         </div>
      </div>
      <div class="otherbtn" @click="confirm()">Confirm</div>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'otherselect',
    props:['otherlist','nowselect'],
    data() {
       return {
          select :{unique_identify:''}
       }
    },
    created(){
        //console.log(this.otherlist)
    },
    mounted() {
        this.select = this.nowselect;
    },
    methods:{
        changeother(l){
          this.select = l;
        },
        confirm(){
          this.$parent.otherconfirm(this.select);
        },
        setcount(count){
          if(count > 1000000000000000000){
            count = outzero((count/1000000000000000000).toPrecision(3))+'bb';
          }else if(count > 1000000000000000){
            count = outzero((count/1000000000000000).toPrecision(3))+'aa';
          }else if(count > 1000000000000){
            count = outzero((count/1000000000000).toPrecision(3))+'t';
          }else if(count > 1000000000){
            count = outzero((count/1000000000).toPrecision(3))+'b';
          }else if(count > 1000000){
            count = outzero((count/1000000).toPrecision(3))+'m';
          }else if(count > 10000){
            count = outzero((count/1000).toPrecision(3))+'k';
          }

          function outzero(val){

            var arr  = val.toString().split('');
            var l = arr.length;
            if(arr[l-1] == 0){
              arr=arr.slice(0,l-1)
            }
            if(arr[arr.length-1] == '.'){
              arr=arr.slice(0,arr.length-1)
            }
            return arr.join('')
          }
          return count;
        },
    },

  }
</script>

<style scoped>
    .mask{
      display: flex;
      justify-content: center;
      align-items: center;
      overflow-x: hidden;
    }
    .otherall{
      width: 66%;
      height: auto;
      background-color: #fff;
    }
    .othertitle{
      font-size: 1rem;
      text-align: center;
      font-family: "SemiBold";
      color: #404D5E;
      line-height: 3rem;
      margin: 0.625rem 0 1rem;
    }
    .othercontent {
      display: flex;
      flex-wrap: wrap;
      padding: 0 0.625rem;
    }
    .othercontent .otheritem{
        width: 33%;
        margin-bottom: 0.625rem;
        box-sizing: border-box;
        position: relative;
        border: 0.1875rem solid #fff;
    }
    .othercontent .otheritem img{
      width: auto;
      height: 3rem;
      display: block;
      margin: 0.625rem auto 0.3rem;
    }
    .othercontent .otheritem span{
      font-size: 0.875rem;
      display: block;
      text-align: center;
      font-weight: 300;
      color: #404D5E;
      margin-bottom: 0.325rem;
      font-family: "Light";
    }
    .othercontent .otherselsct{
      border: 0.1875rem solid #3BE487;
    }
    .othercontent .otheritem .otherimg{
      position: absolute;
      top: -0.125rem;
      right: -0.125rem;
      width: 1.5rem;
      height: auto;
      margin: 0;
    }
    .otherbtn{
      width: 9.5rem;
      height: 2.5rem;
      background: #58A8A5;
      border-radius: 8px;
      font-size: 1.125rem;
      text-align: center;
      margin: 0.625rem auto 1.25rem;
      font-weight: 900;
      color: #FFFFFF;
      font-family: "Regular";
      line-height: 2.5rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/otherselect.vue